/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalTab } from '../Modal';
import { ControlTable } from '../Table';
import Profile from '../Profile';
import { REACTIONS } from '../../constants/REACTION';
import { isEmpty } from '../../utils/lodashExtend';
import Icon from '../Icon';

const ReactionEmployees = ({ open, setOpen, submit, list }) => {
  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    submit && submit();
    setOpen(false);
  };
  const [activeTab, setActiveTab] = useState("all");
  const [employeeList, setEmployeeList] = useState([]);

  const [tabList, setTabList] = useState([
    {
      action: setActiveTab,
      label: "전체",
      value: "all",
    },
    ...REACTIONS.map(item => {
      return {
        action: setActiveTab,
        label: item.label,
        value: item.key,
      };
    })
  ]);

  useEffect(() => {
    if (!isEmpty(list) && !isEmpty(activeTab)) {
      if (activeTab === "all") {

        const allList = [];

        Object.entries(list).forEach(([, value]) => {
          allList.push(...value);
        });

        setEmployeeList(allList);
      } else {
        setEmployeeList(list[activeTab]);
      }
    }
  }, [activeTab, list]);

  useEffect(() => {
    if (!isEmpty(list)) {
      const _keys = Object.keys(list);

      const _totalCnt = _keys.reduce((acc, item) => {
        acc = acc + ((list[item] || []).length || 0);
        return acc;
      }, 0);


      const _tabList = [
        {
          action: setActiveTab,
          label: `전체(${_totalCnt})`,
          value: "all",
        },
        ...REACTIONS.map(item => {

          return {
            action: setActiveTab,
            label: (
              <>
                {item.icon ? <Icon style={{ verticalAlign: 'top' }} width="24px" height="24px" src={item.icon} /> : item.label}{`(${(list[item.key] || []).length || 0})`}
              </>
            ),
            value: item.key,
          };
        })
      ];

      setTabList(_tabList);
    }
  }, [list]);

  const [fields] = useState([
    {
      key: "employee", onValue: (v) => {
        return <Profile data={v} isProfileImage={true} />;
      }
    },
    {
      key: "type", onValue: (v) => {
        const item = REACTIONS.find(f => f.key === v);
        return item.icon ? <Icon style={{ verticalAlign: 'top' }} width="24px" height="24px" src={item.icon} /> : item.label;
      }
    },
    { type: "datetime", key: "createdTime" }
  ]);

  return (
    <Modal
      isOpen={open}
      close={cancel}
      size="sm"
    >
      <ModalTab tabList={tabList} active={activeTab} tabClassName={"reaction-nav"} />
      <ControlTable
        isHideControlHeader
        isHideHeader
        fields={fields}
        list={employeeList}
      />
    </Modal>
  );
};

export default ReactionEmployees;